import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';

import SimpleHeader from 'components/Headers/SimpleHeader.js';
import Loader from 'components/Loader';

import ActiveWhatsappBlockInputs from '../FormInputs';
import WhatsappBlockListService from '../../../services';

const EditActiveWhatsappBlock = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [blockedNumber, setBlockedNumber] = useState(null);

  const getBlockedNumber = useCallback(() => {
    setIsLoading(true);
    WhatsappBlockListService.getById(id)
      .then((response) => {
        setBlockedNumber(response.data);
      })
      .catch(() => {
        toast.error(
          'Ocorreu um erro ao buscar informações do número bloqueado'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getBlockedNumber();
  }, [getBlockedNumber]);

  if (isLoading) {
    return (
      <Row className="justify-content-md-center">
        <Loader />
      </Row>
    );
  }

  return (
    <>
      <SimpleHeader
        name="Edição de Número Bloqueado"
        parentName="Números Bloqueados"
        returnPath="/admin/chat/active-whatsapp-block-list"
      />
      <Container className="configuration-container mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <div className="d-flex flex-row justify-content-between">
                    <h3 className="mb-0">Editar um número bloqueado</h3>
                  </div>
                </CardHeader>
                <CardBody className="pt-2">
                  <ActiveWhatsappBlockInputs blockedNumber={blockedNumber} />
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditActiveWhatsappBlock;
